/**
 * 联系
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/17      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React,{Fragment} from 'react'
import PropTypes from "prop-types";
import {Drawer,Input,Button,Tooltip,message,Empty,Modal} from 'antd';
import Lang from "@components/Lang/Lang";
import "./index.less";
import dayjs from 'dayjs';
import UploadFile from "./components/UploadFile";
import FileList from "./components/FileList/FileList";
import {toCutByte} from '@utils/utils';

class Contact extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            visible:false,
            tooltipVisible:false,
            submitLoading:false,
            uploadLoading:false,
            content:'',
            list:[],
            fileList:[],
            height:164 // header 55px  footer 91px mt 16
        }
        this.needUpdate = false;
    }

    getData(){
        this.setState({
            loading:true
        },()=>{
            let state = {
                loading:false
            }
            $.ajax({
                url: "/service/mg/fuzzy/msg-record/list",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify({
                    id:this.props.fuzzyId
                }),
                success:(res)=>{
                    if(res.success&&res.valid){
                        state.list = res.models||[];
                    }
                    this.setState(state,()=>{
                        $(".fuzzy-contact__main").scrollTop($(".fuzzy-contact__main")[0].scrollHeight);
                    });
                },
                error:()=>{
                    this.setState(state);
                }
            });
        })
    }

    /**
    * 切换显示
    **/
    changeVisible(visible){
        if(visible){
            if(this.props.disabled){
                this.props.tipBind();
                return false;
            }
        }
        let state = {
            visible:visible
        }
        if(visible){
            state.content = '';
            state.fileList = [];
            state.height = 164;
        }
        this.setState(state,()=>{
            if(visible){
                this.getData();
            }else{
                if(this.needUpdate||this.props.model.isNewMessage){
                    if(typeof this.props.callback == 'function'){
                        this.props.callback()
                    }
                }
            }
        })
    }

    /**
     * 修改上传图片
     * @param imgList
     */
    onChangeImgList(fileList){
        let state = {
            fileList:[].concat(fileList)
        }
        if(fileList.length>0){
            state.height = 230; //header 55 footer 153 mt 16
        }else{
            state.height = 164; //header 55 footer 91px mt 16
        }
        this.setState(state,()=>{
            this.forceUpdate();
        })
    }

    changeInput(e){
        let value = e.target.value;
            value = toCutByte(value,1000);
        this.setState({
            content:value
        })
    }

    sumbit(){
        this.setState({
            submitLoading:true
        },()=>{
            let state = {
                submitLoading:false
            }
            let postData = {
                id:this.props.fuzzyId
            };
            if(this.state.content){
                postData.content = $.trim(this.state.content);
            }
            if(this.state.fileList&&this.state.fileList.length>0){
                postData.fileList = [];
                this.state.fileList.forEach((item)=>{
                    postData.fileList.push({
                        fileExtend:item.extend,
                        fileId:item.fileId,
                        fileName:item.fileName,
                    })
                })
            }
            if(!postData.content&&postData.fileList.length==0){
                message.info(__getServerLanguage('ShuRuKuangBuNengWeiKong'));
                this.setState(state);
                return false;
            }
            $.ajax({
                url: "/service/mg/fuzzy/msg-record/submit",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify(postData),
                success:(res)=>{
                    if(res.success&&res.valid){
                        state.content = '';
                        state.fileList = [];
                        state.height = 164;
                        this.needUpdate = true;
                        message.success(__getServerLanguage('FaSongChengGong'));
                        this.getData();
                    }
                    this.setState(state);
                },
                error:()=>{
                    this.setState(state);
                }
            });
        })
    }

    changeTooltipVisible(visible){
        this.setState({
            tooltipVisible:visible
        })
    }

    render(){
        const {list,uploadLoading} = this.state;
        const content = this.state.content?$.trim(this.state.content):'';
        const footerHeight = this.props.showEdit?0:107;
        const calculatedHeight = `calc(100vh - ${this.state.height-footerHeight}px)`;
        return (
            <Fragment>
                <span onClick={this.changeVisible.bind(this,true)}>
                    {this.props.children}
                </span>
                <Drawer title={this.props.title}
                        placement={"right"}
                       maskClosable={false}
                       className="fuzzy__modal-wrap"
                       open={this.state.visible}
                        onClose={this.changeVisible.bind(this,false)}
                       width={700}>
                    <div className="fuzzy-contact__wrap">
                        <div className="fuzzy-contact__main"
                             style={{height:calculatedHeight}}>
                            {
                                list.map((item,index)=>{
                                    return <div className={index==0?'':'mt_16'} key={index}>
                                        <ul>
                                            <li className={`${item.createPlatform!=='essaone'?'right-item':'left-item'}`}>
                                                {
                                                    item.createPlatform!=='essaone'?
                                                        <img className="img" src="http://oss.essa.cn/16841699-b1a3-43b3-bbf6-2b99b7a76937.svg" alt=""/>
                                                        :
                                                        <div className="img buyer-img">{item.buyerCode||'-'}</div>
                                                }
                                                <div className="content">
                                                    <div className="text">{item.content}</div>
                                                    {
                                                        item.createPlatform=='essaone'&&item.translateContent?
                                                            <div className="content-footer">
                                                                {item.translateContent}
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        item.fileList&&item.fileList.length>0?
                                                            <div className={`${item.content?'mt_2':''}`}>
                                                                <FileList canDelete={false}
                                                                          fileUrl="fileUrl"
                                                                          list={item.fileList}></FileList>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </li>
                                        </ul>
                                        <div className={`${item.createPlatform!=='essaone'?'text-right mr_48':'text-left ml_48'} mt_4 color045 font_12`}>{item.createTime?dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</div>
                                    </div>
                                })
                            }
                            {
                                list.length==0?
                                    <Empty description={Lang({id: "ZanWuShuJu", default: "暂无数据"})}></Empty>
                                    :
                                    null
                            }
                        </div>
                        {
                            this.props.showEdit?
                                <div className="fuzzy-contact__footer">
                                    <div className="flex-box">
                                        <Input.TextArea className="mr_8"
                                                        rows={2}
                                                        maxLength={1000}
                                                        size="large"
                                                        value={this.state.content}
                                                        onChange={this.changeInput.bind(this)}
                                                        placeholder={__getServerLanguage('QingShuRu')}></Input.TextArea>
                                        <Tooltip placement="topRight"
                                                 open={this.state.tooltipVisible}
                                                 onOpenChange={this.changeTooltipVisible.bind(this)}
                                                 getPopupContainer={triggerNode => triggerNode.parentElement}
                                                 title={__getServerLanguage('ShangChuanWenJianZhiChi')}>
                                            {
                                                this.state.fileList.length>=5?
                                                    <Button size="large" disabled={true}>
                                                        <i className="font_24 lineH_24">+</i>
                                                    </Button>
                                                    :
                                                    <span onClick={this.changeTooltipVisible.bind(this,false)}>
                                                            <UploadFile defaultList={this.state.fileList}
                                                                        fileSizeLimit={209715200}
                                                                        changeLoading={(loading)=>{
                                                                            this.setState({
                                                                                uploadLoading:loading
                                                                            })
                                                                        }}
                                                                        accept={{
                                                                            title: __getServerLanguage('WenJian'),
                                                                            extensions: 'jpeg,jpg,png,gif,xls,xlsx,zip,rar,7z',
                                                                        }}
                                                                        onChange={this.onChangeImgList.bind(this)}>
                                                                <Button size="large">
                                                                    <i className="font_24 lineH_24">+</i>
                                                                </Button>
                                                            </UploadFile>
                                                        </span>
                                            }
                                        </Tooltip>
                                        <Button type="danger"
                                                disabled={(this.state.fileList.length==0&&!content)||uploadLoading}
                                                loading={this.state.submitLoading}
                                                onClick={this.sumbit.bind(this)}
                                                className="ml_8 flex-box align-items-center"
                                                size="large">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M1.62168 7.76286C1.18623 7.61771 1.18279 7.38352 1.63064 7.23424L17.5358 1.93251C17.9762 1.78571 18.2288 2.03222 18.1054 2.46412L13.561 18.3693C13.4352 18.8097 13.1814 18.825 12.9953 18.4063L9.99988 11.6667L14.9999 5.00004L8.33322 10L1.62168 7.76286Z"
                                                      fill={((this.state.fileList.length==0&&!content)||uploadLoading)?'rgba(0,0,0,0.25)':'white'}
                                                />
                                            </svg>
                                            <span className="ml_8 font_14">{__getServerLanguage('FaSong')}</span>
                                        </Button>
                                    </div>
                                    <FileList canDelete={true} onChange={this.onChangeImgList.bind(this)} fileUrl="url" list={this.state.fileList}></FileList>
                                </div>
                                :
                                null
                        }
                    </div>
                </Drawer>
            </Fragment>
        )
    }
}

Contact.defaultProps = {
    title:__getServerLanguage('LianXiShangPinJingLi'),
    showEdit:false,
    disabled:false,
    tipBind:function(){

    },
    callback:function () {

    }
}

Contact.propTypes = {

}
export default Contact;
